export const FBA_MAX_CASE_DIMENSION_IN = 100000;
export const FBA_MAX_CASE_WEIGHT_LB = 100000;
export const FBA_MIN_PARCEL_NUMBER_OF_BOXES = 1;
export const FBA_MAX_PARCEL_NUMBER_OF_BOXES = 200;
export const FBA_MAX_PARCEL_NUMBER_OF_BOXES_VIA_FLEXPORT = 500;
export const FBA_MIN_FREIGHT_NUMBER_OF_BOXES = 1;
export const FBA_MAX_FREIGHT_NUMBER_OF_BOXES = 5000;
export const AMAZON_MAX_NUMBER_OF_PALLETS = 26;
